$(document).ready(function(){
  //$("#shopify-section-164380281339460d36").append("<img class='greenrect' src='https://cdn.shopify.com/s/files/1/0621/8278/5260/files/Rectangle_495_2x_1.png?v=1644267156'>");
  
  var windowWidth = $(window).width();
  
  /* Header login */
  
  if (windowWidth > 1024){
    let login = $(".tt-desktop-header .tt-desctop-parent-account");
  
    let loginIcon = login.find(".tt-dropdown-toggle");

    let link = login.find(".tt-dropdown-inner li a").first().attr("href");

    loginIcon.wrap($("<a href='"+ link +"'></a>"));

    if (link == "/account/login"){
      loginIcon.append($("<span>Inloggen</span>"));
    }
    else{
      loginIcon.append($("<span>Account</span>"));
    }



    let cart = $(".tt-desktop-header .tt-desctop-parent-cart");
    let cartIcon = cart.find(".tt-dropdown-toggle");

    cartIcon.append($("<span>Winkelwagen</span>"));

    let search = $(".tt-desktop-header .tt-desctop-parent-search");
    let searchIcon = search.find(".tt-dropdown-toggle");

    searchIcon.append($("<span>Zoeken</span>"));


    cart.insertAfter(login);
    
    cart = $(".tt-stuck-nav .tt-stuck-parent-cart");
    login = $(".tt-stuck-nav .tt-stuck-parent-account");
    cart.insertAfter(login);
    
  }
  
  /* Hero */
  
  if (windowWidth < 1024){
   
    
    $("#shopify-section-164380281339460d36 .tt-promo-fullwidth img").attr("src","https://cdn.shopify.com/s/files/1/0621/8278/5260/files/image_31_1.jpg?v=1644937857");
    $("#shopify-section-164380281339460d36 .tt-promo-fullwidth img").attr("srcset","https://cdn.shopify.com/s/files/1/0621/8278/5260/files/image_31_1.jpg?v=1644937857");
    $("#shopify-section-164380281339460d36 .tt-promo-fullwidth img").attr("data-srcset","https://cdn.shopify.com/s/files/1/0621/8278/5260/files/image_31_1.jpg?v=1644937857");
    $("#shopify-section-164380281339460d36 .tt-promo-fullwidth img").attr("data-mainimage","https://cdn.shopify.com/s/files/1/0621/8278/5260/files/image_31_1.jpg?v=1644937857");
  }
  
  
  
  
  /* Homepage Slider */
  
  
  let sliderSectie = $("#shopify-section-1521705177678");
  
  
  let widthSlider = sliderSectie.find(".tt-carousel-products-js").width();
  
  
  var products = sliderSectie.find(".tt-layout-product-item");
  products.wrap($("<div class='slider'></div>"));
  
  
  var slider = sliderSectie.find(".slider");

  slider.prepend(jQuery("<div class='overlayProducts'></div>"));

  setTimeout(function(){
      if (jQuery(window).width() > 767){
           slider.css("width","110%");
      }
  }, 1000)



  var time = 650;
  var viewWidth = jQuery(window).width();

  var product = products.find(".col-6.col-md-4.col-lg-4");


  products.width(Math.floor(products.width()));

  sliderSectie.append($('<div class="pageProducts"><span class="bullet bullet1 activeBullet"></span><span class="bullet bullet2"></span><span class="bullet bullet3"></span><span class="bullet bullet4"></span></div>'));

  if (windowWidth < 1024){
  	var width = product.width() + 10;
  }
  
  else{
    var width = product.width() + 30;
  }
  var transX = 0;
  
  pagination();
  
  function pagination(){
    let totalWidth
    if (windowWidth < 1024){
       totalWidth  = width * (product.size() -2);
    }
    else {
       totalWidth = width * (product.size() -3);
    }
      
    
      let pageni = jQuery(".pageProducts");
      let bullets = pageni.find(".bullet");
      let first = totalWidth * 0.25;
      let second = totalWidth * 0.5;
      let third = totalWidth * 0.75;

      if (transX >= 0 && transX < first){
          bullets.removeClass("activeBullet");
          pageni.find(".bullet1").addClass("activeBullet");
      }
      else if (transX >= first && transX < second){
          bullets.removeClass("activeBullet");
          pageni.find(".bullet2").addClass("activeBullet");
      }
      else if (transX >= second && transX < third){
          bullets.removeClass("activeBullet");
          pageni.find(".bullet3").addClass("activeBullet");
      }
      else {
          bullets.removeClass("activeBullet");
          pageni.find(".bullet4").addClass("activeBullet");
      }
  }

  let pressed = false;
  let startx;
  let currentTransX;

  slider.mousedown(function(evt){
      pressed = true;
      startx = evt.pageX;
      currentTransX = transX;
  });

  jQuery(window).mouseup(function(){
     pressed = false; 
     products.find("a").removeClass("noEvents");
     products.find("div").removeClass("noEvents");
  });

  slider.mousemove(function(e){
     if(!pressed){
         return;
     } 

     products.find("a").addClass("noEvents");
    products.find("div").addClass("noEvents");

     e.preventDefault();
     var x = e.pageX;
     var distance = x - startx;

     transX = currentTransX - distance;
     if (transX > (product.width() +20) * (product.size() - 3)){
         transX = (product.width() +20) * (product.size() - 3);
     }
     if (transX < 0 ){
         transX = 0;
     }

	 pagination();
     products.css("transform","translate(-" + transX +"px, 0px)");
  });
  
  
  
  let sliderTouched = false;
  let startxmobile = 0;
  let movedleft = false;
  let movedright = false
  var slideTrans = 0;

  slider.on("touchstart", function(e){
      sliderTouched = true;
      startxmobile = e.originalEvent.touches[0].pageX;
      currentTransX = transX;
  });


  slider.on("touchmove",function(e){

      if (!sliderTouched){
          return
      }

      var distance = e.originalEvent.touches[0].pageX - startxmobile;

      slideTrans = currentTransX - distance;

      products.css("transform","translate(-" + slideTrans +"px, 0px)");

      if (distance > 60){
          movedright = true;
      }
      if (distance < -60){
          movedleft = true;
      }
  });


  jQuery(window).on("touchend", function(e){

      if (movedleft){
          if ((transX + width) < (product.width() + 10) * (product.size() - 1))
         {

         products.css("transition-duration", (time -300) + "ms");

          transX += width;

          products.css("transform","translate(-" + transX +"px, 0px)");

         setTimeout(function(){
             products.css("transition-duration", "0ms");
         }, time);
 
         }
        pagination();
      }

      else if(movedright){
          if (transX > 0)
           {

           products.css("transition-duration", (time - 300) + "ms");

            transX -= width;

            products.css("transform","translate(-" + transX +"px, 0px)");

           setTimeout(function(){
               products.css("transition-duration", "0ms");
           }, time);

           }
        pagination();

      }

      else {
          products.css("transform","translate(-" + transX +"px, 0px)");
      }


      sliderTouched = false;
      movedleft = false;
      movedright = false;

  });
  
  
  jQuery("#shopify-section-1521705177678 .pageProducts .bullet").click(function(){
    
    let bullet = jQuery(this);
    
    let totalWidth
    if (windowWidth < 1024){
       totalWidth  = width * (product.size() -2);
    }
    else {
       totalWidth = width * (product.size() -3);
    }
    
    let first = totalWidth * 0.25;
    let second = totalWidth * 0.5;
    let third = totalWidth * 0.75;
    
    if (bullet.hasClass("bullet1")){
      transX = 0;
      products.css("transition-duration", (time - 300) + "ms");

      products.css("transform","translate(-" + transX +"px, 0px)");

      setTimeout(function(){
        products.css("transition-duration", "0ms");
      }, time);
      
    }
    else if (bullet.hasClass("bullet2")){
      transX = first;
      products.css("transition-duration", (time - 300) + "ms");

      products.css("transform","translate(-" + transX +"px, 0px)");

      setTimeout(function(){
        products.css("transition-duration", "0ms");
      }, time);
    }
    else if (bullet.hasClass("bullet3")){
      transX = second;
      products.css("transition-duration", (time - 300) + "ms");

      products.css("transform","translate(-" + transX +"px, 0px)");

      setTimeout(function(){
        products.css("transition-duration", "0ms");
      }, time);
    }
    else{
       transX = third;
      products.css("transition-duration", (time - 300) + "ms");

      products.css("transform","translate(-" + transX +"px, 0px)");

      setTimeout(function(){
        products.css("transition-duration", "0ms");
      }, time);
    }
    
    pagination();
    
    
  });
  
  
  
  $(".leftColumn .tt-collapse").click(reloadProducts);
      
  
  function reloadProducts(){
    let interval = setInterval(function(){
      
      if ($(".tt-product .tt-btn-addtocart svg").length == 0 ) {
        	
        let button = $(".tt-product-inside-hover");
        button.find(".tt-btn-addtocart").append($('<svg class="arrow" xmlns="http://www.w3.org/2000/svg" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="24"><line x1="5" x2="19" y1="12" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>'));
        if (windowWidth <1024){
          $(".levertijd").html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"></path></svg> 2 werkdagen in huis');
        }
        clearInterval(interval);
      }

    },300);



  }
    
    
  
  
  $(".tt-product").each(function(){
    let prod = $(this);
    
    prod.find(".new-price").before(prod.find(".old-price"));
    
    let button = prod.find(".tt-product-inside-hover");
    
    prod.append(button);
    
    button.find(".tt-btn-addtocart").append($('<svg class="arrow" xmlns="http://www.w3.org/2000/svg" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="24"><line x1="5" x2="19" y1="12" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>'));
    
    
    
  });
  
  $(".tt-filters-options .tt-btn-toggle a").prepend(jQuery('<svg xmlns="http://www.w3.org/2000/svg" id="Group_35" data-name="Group 35" width="66.58" height="57.184" viewBox="0 0 66.58 57.184"><path id="Path_16" data-name="Path 16" d="M-170.816-274.868q7.167,0,14.334,0c1.011,0,2.023.02,3.032-.024.527-.023,1.044.071,1.571.034.56-.04,1.125-.009,1.688-.009h5.025c.667,0,.647-.008.877-.624a8.861,8.861,0,0,1,7.527-6.133,9,9,0,0,1,9.806,6.368.461.461,0,0,0,.519.393c1.524-.011,3.048.006,4.572-.011.387,0,.536.109.529.512q-.031,1.771,0,3.542c.007.409-.151.512-.532.508-1.455-.016-2.911.009-4.366-.014a.683.683,0,0,0-.79.553,9.08,9.08,0,0,1-8.732,6.294,9.07,9.07,0,0,1-8.531-6.292.687.687,0,0,0-.785-.557q-20.966.016-41.932.009a3.9,3.9,0,0,0-.412,0c-.349.037-.48-.083-.473-.459.024-1.235.019-2.471,0-3.707,0-.309.076-.394.39-.393Q-179.158-274.861-170.816-274.868Zm39.725,2.284a4.573,4.573,0,0,0-4.529-4.585,4.615,4.615,0,0,0-4.608,4.551,4.578,4.578,0,0,0,4.533,4.589A4.563,4.563,0,0,0-131.091-272.583Z" transform="translate(187.916 301.197)"/><path id="Path_17" data-name="Path 17" d="M-136.028-34.24c-4.64,0-9.281.006-13.921-.008a.636.636,0,0,0-.723.517,8.825,8.825,0,0,1-6.667,6.088,8.747,8.747,0,0,1-8.4-2.412,8.587,8.587,0,0,1-2.277-3.753.533.533,0,0,0-.615-.437q-6.013.013-12.026.005c-2.292,0-4.585-.007-6.877.006-.363,0-.5-.083-.494-.48.023-1.235.014-2.471-.012-3.706-.008-.364.192-.366.44-.366h9.761c3.031,0,6.062-.006,9.093.009a.67.67,0,0,0,.764-.53,8.843,8.843,0,0,1,7.366-6.208,8.7,8.7,0,0,1,7.288,2.177,8.784,8.784,0,0,1,2.684,4.156c.113.367.343.4.653.4q3.913-.007,7.825,0h19.852c.927,0,.831-.042.832.812q0,1.524,0,3.048c0,.686,0,.686-.667.686Zm-23.343,2.291a4.58,4.58,0,0,0,4.619-4.534,4.613,4.613,0,0,0-4.525-4.6,4.589,4.589,0,0,0-4.635,4.484A4.57,4.57,0,0,0-159.371-31.949Z" transform="translate(188.054 84.575)"/><path id="Path_18" data-name="Path 18" d="M-141.742-506.927h-17.875c-.59,0-1.181.019-1.77-.006a.515.515,0,0,0-.583.439,9.022,9.022,0,0,1-3.236,4.6,8.926,8.926,0,0,1-4.538,1.782,8.741,8.741,0,0,1-4.73-.795,8.915,8.915,0,0,1-4.838-5.485.667.667,0,0,0-.777-.548c-2.553.019-5.107,0-7.661.02-.388,0-.442-.117-.438-.462q.022-1.914-.021-3.829c-.007-.31.17-.219.313-.219,2.595,0,5.19-.011,7.784.013a.706.706,0,0,0,.808-.573,8.9,8.9,0,0,1,7.664-6.237,8.479,8.479,0,0,1,5.544,1.167,8.936,8.936,0,0,1,4.078,5.07.716.716,0,0,0,.825.572q19.358-.018,38.716-.009a3.175,3.175,0,0,0,.37,0c.362-.042.48.113.475.471q-.024,1.812,0,3.624c0,.328-.1.414-.426.413q-6.692-.017-13.384-.009Zm-24.341-2.226a4.636,4.636,0,0,0-4.61-4.613,4.584,4.584,0,0,0-4.522,4.6,4.559,4.559,0,0,0,4.57,4.583A4.62,4.62,0,0,0-166.083-509.153Z" transform="translate(188.209 518.3)"/></svg>'));
  
  if (windowWidth <1024){
    setTimeout(function(){
      $(".slick-list .levertijd").html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"></path></svg> Vóór 23:00 uur besteld? Vandaag verzonden!');
    	
      $(".tt-layout-product-item .levertijd").html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"></path></svg> Vóór 23:00 uur besteld? Vandaag verzonden!');
      
    	
    
    },1000);
    
  }
  
  
  
  
  /* Sectie 3, highlighted collection */
  

  
  /* Sectie 4, over ons */
  
  $("#shopify-section-1644698912e1d56922").append($("#shopify-section-1644698912e1d56922 .img1"));
  $("#shopify-section-1644698912e1d56922").append($("#shopify-section-1644698912e1d56922 .img2"));
  
  
  
  /* Sectie 5 SEO tekst */
  
  $("#shopify-section-164470730234ba2ef8 .readmoreWrap").click(function(){
	$(this).css('display', 'none');
    $("#shopify-section-164470730234ba2ef8 .overlay").css('display', 'none');
    $("#shopify-section-164470730234ba2ef8 .description").css("height", "auto");
    
  });
  
   $(".SEOTekst .readmoreWrap").click(function(){
	$(this).css('display', 'none');
    $(".SEOTekst .overlay").css('display', 'none');
    $(".SEOTekst .description").css("height", "auto");
    
  });
  
  
  
  
  /* Collection page */
  
  let collectionPage = $(".pagecollection");
  

  
  let title = $(".tt-breadcrumb ul li:last-child").text();
  $(".tt-breadcrumb .container").append('<h1 class="tt-title">' + title + '</h1>');
  
  
  collectionPage.find(".tt-sort").prepend($("<span>Sorteer op: </span>"));
  $("<span style='margin-left:15px;'>Aantal producten: </span>").insertBefore(collectionPage.find(".tt-sort .show-qty"));
  
  

  	/* product page */
  
  
  
  let productPage = $(".pageproduct");
  
  
  if (viewWidth < 1024){
    let beschrijving = productPage.find(".prpage-tabs .tt-item.active");
     let specificaties = productPage.find(".secondrow .col-6:nth-child(2)");
    
    specificaties.insertAfter(beschrijving);
    specificaties.remove();
  }
  
  
  
  
  let interval4 = setInterval(function(){
    
    
    let variantButtons = productPage.find(".tt-swatches-container");
    if (variantButtons.length > 0){
      productPage.find(".tt-swatches-container").click(function(){
        const variants = document.querySelectorAll('[data-variant-id]');

        variants.forEach( function(variant) {
          //hide all variant descriptions
          variant.style.display = 'none';
          
          if(variant.dataset.variantId == window.location.search.slice(1).split("=")[1]){
            //if current variant unhide the variant description
            variant.style.display = 'block';
          }
        });
      });
      
      clearInterval(interval4);
    }
    
  },10);
  
  
  
  
  
   
  
  productPage.find(".container > .row > .col-6:first .slick-arrow").click(productImage);
  
  let i = setInterval(function(){
    let gallery = productPage.find("#smallGallery .slick-slide a");
    
    if (gallery.length > 0 ){
      gallery.click(productImage);
      clearInterval(i);
    }
    
  },100);
  
  
  
  function productImage(){;
    setTimeout(function(){
      let productPicture = productPage.find(".tt-product-single-img .mediaimageholder img");
      let height = productPicture.height();

      productPage.find(".zoomContainer").height(height);
      productPage.find(".zoomContainer .zoomWindow").height(height);
    },200);
    
  }
  

  
  productPage.find(".leesmeer").click(function(){

    productPage.find(".shortDescription").css("height", "auto");
    $(this).css("display", "none");
  });
  
 
  addIcon();
  
  function addIcon(){
    setTimeout(function(){
    $(".pageproduct #shopify-section-product-template .tt-product-single-info .tt-row-custom-01 .btn").append($('<span>Voeg toe aan winkelwagen</span><svg class="arrow" xmlns="http://www.w3.org/2000/svg" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewbox="0 0 24 24" width="24"><line x1="5" x2="19" y1="12" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>'));
    $(".pageproduct #shopify-section-product-template .tt-product-single-info .tt-row-custom-01 .btn .icon").remove();

      $(".pageproduct #shopify-section-product-template .options-color").click(addIcon);

      $(".pageproduct #shopify-section-product-template .options-color").on("touchstart", addIcon);
      
    },500);
  }
  
  let specs =  $(".pageproduct #shopify-section-product-template .specificaties");
  
  specs.each(function(){
    
    let spec = $(this);
    let specList = spec.text().split(';');
      spec.text("");
      for (let i = 0 ; i < specList.length - 1; i++){

        spec.append($("<div class='spec'><div class='specName'>" + specList[i].split(',')[0] + "</div><div class='specValue'>" + specList[i].split(',')[1] + "</div></div>"));


      }
  });
  
  
  
  if ($(".pageproduct #shopify-section-product-template .specificaties").text() == ""){
    
    $(".pageproduct #shopify-section-product-template .specificatiesTitel").css("display", "none");
  }
  
  let shortDesc = $(".pageproduct #shopify-section-product-template .shortDescription");
  if (parseInt(shortDesc.css("height"), 10) > 68){
    shortDesc.css("height", "80px");
    
  }
  else {
    $(".pageproduct #shopify-section-product-template .leesmeer").css("display", "none");
  }
  
  let relatedSlider;
  let rwidth;
  
  function paginationProduct(){
    let totalWidth
    
    let slides = relatedSlider.find(".slick-slide");
    let slidesCount
    let trans
    
    if (windowWidth < 1024){
      slidesCount = slides.length - 6;
      trans = Math.abs(parseInt(relatedSlider.css("transform").split(',')[4]) + rwidth * 2);
    }
    else {
      slidesCount = slides.length - 7;
      trans = Math.abs(parseInt(relatedSlider.css("transform").split(',')[4]) + rwidth * 3);
    }
    
    totalWidth = rwidth * slidesCount;
    
    let pageni = jQuery(".pageProducts");
    let bullets = pageni.find(".bullet");
    let first = totalWidth * 0.25;
    let second = totalWidth * 0.5;
    let third = totalWidth * 0.75;

    if (trans >= 0 && trans < first){
      bullets.removeClass("activeBullet");
      pageni.find(".bullet1").addClass("activeBullet");
    }
    else if (trans >= first && trans < second){
      bullets.removeClass("activeBullet");
      pageni.find(".bullet2").addClass("activeBullet");
    }
    else if (trans >= second && trans < third){
      bullets.removeClass("activeBullet");
      pageni.find(".bullet3").addClass("activeBullet");
    }
    else {
      bullets.removeClass("activeBullet");
      pageni.find(".bullet4").addClass("activeBullet");
    }
  }
  
  
   
  
  
  let rpressed = false;
  
  
  let relatedInterval = setInterval(function(){
    
    
    relatedSlider = $(".pageproduct .tt-carousel-products .slick-track");
	
    
    if (relatedSlider.length > 0){
          
      $(".pageproduct .tt-carousel-products").append($('<div class="pageProducts"><span class="bullet bullet1 activeBullet"></span><span class="bullet bullet2"></span><span class="bullet bullet3"></span><span class="bullet bullet4"></span></div>'));
      
           
      
      if (windowWidth < 1024){
        rwidth =  relatedSlider.find(".slick-slide").width() + 10;
      }

      else{
        rwidth = relatedSlider.find(".slick-slide").width() + 30;
      }
      
      paginationProduct();
      
      relatedSlider.mousedown(function(evt){
        rpressed = true;
      });
                         
      relatedSlider.mousemove(function(){
        if (!rpressed){
          return;
        }
        
        
        
      });	
      
      relatedSlider.mouseup(function(){
        setTimeout(function(){
          paginationProduct();
        }, 500);
        
      });
      
      relatedSlider.on("touchend", function(){
        setTimeout(function(){
          paginationProduct();
        }, 500);
      });
      
      
      let relatedWidth;
      let relatedProduct = relatedSlider.find(".slick-slide");

      if (windowWidth < 1024){
        relatedWidth = relatedProduct.width() + 10;
      }

      else{
        relatedWidth = relatedProduct.width() + 30;
      }
      
      let allBullets = jQuery("#shopify-section-product-template .bullet");

      allBullets.click(function(){

        let bullet = jQuery(this);

        let totalWidth;
        if (windowWidth < 1024){
           totalWidth  = relatedWidth * (relatedProduct.size() -2);
        }
        else {
           totalWidth = relatedWidth * (relatedProduct.size() -3);
        }
        

        let first = totalWidth * 0.25;
        let second = totalWidth * 0.5;
        let third = totalWidth * 0.75;

        if (bullet.hasClass("bullet1")){
          transX = 0;
          relatedSlider.css("transition-duration", (time - 300) + "ms");

          relatedSlider.css("transform","translate(-" + transX +"px, 0px)");
			allBullets.removeClass("activeBullet");
          bullet.addClass("activeBullet");
          setTimeout(function(){
            relatedSlider.css("transition-duration", "0ms");
          }, time);

        }
        else if (bullet.hasClass("bullet2")){
          transX = first;
          relatedSlider.css("transition-duration", (time - 300) + "ms");

          relatedSlider.css("transform","translate(-" + transX +"px, 0px)");
		allBullets.removeClass("activeBullet");
          bullet.addClass("activeBullet");
          setTimeout(function(){
            relatedSlider.css("transition-duration", "0ms");
          }, time);
        }
        else if (bullet.hasClass("bullet3")){
          transX = second;
          relatedSlider.css("transition-duration", (time - 300) + "ms");

          relatedSlider.css("transform","translate(-" + transX +"px, 0px)");
allBullets.removeClass("activeBullet");
          bullet.addClass("activeBullet");
          setTimeout(function(){
            relatedSlider.css("transition-duration", "0ms");
          }, time);
        }
        else{
           transX = third;
          relatedSlider.css("transition-duration", (time - 300) + "ms");

          relatedSlider.css("transform","translate(-" + transX +"px, 0px)");
allBullets.removeClass("activeBullet");
          bullet.addClass("activeBullet");
          setTimeout(function(){
            relatedSlider.css("transition-duration", "0ms");
          }, time);
        }



      });
      

      clearInterval(relatedInterval);
    }   
  },200);
  
  
  
  /* Footer */
  $("#shopify-section-footer-template .tt-social-icon").insertAfter($("#shopify-section-footer-template h3.connect"));
  
  
  let footer = $("#shopify-section-footer-template");
  
  let upperfooter = $("<div class='upperfooterWrap'><div class='container'></div></div>");
  
  upperfooter.insertBefore(footer);
  
  upperfooter = $(".upperfooterWrap .container");
  
  let leftColumn = $("<div class='col-sm-4'></div>");
  
  let rightColumn = $("<div class='col-sm-8'></div>");
  
  rightColumn.append($("#shopify-section-footer-template .tt-footer-custom .tt-payment-list"));
  leftColumn.append($('<div id="trustpilot-widget-trustbox-0-wrapper" style="z-index: 1000; clear: both;margin-left: 0px; margin-right:  0px;margin-top: 0px; margin-bottom: 0px;"><div class="trustpilot-widget" data-locale="en-US" data-template-id="5419b6a8b0d04a076446a9ad" data-businessunit-id="61aded47ddc90238cd0fc2ac" data-style-height="24px" data-style-width="100%" data-theme="light" id="trustpilot-widget-trustbox-0" style="z-index: 1000 !important; position: relative;"><iframe title="Customer reviews powered by Trustpilot" loading="auto" src="https://widget.trustpilot.com/trustboxes/5419b6a8b0d04a076446a9ad/index.html?templateId=5419b6a8b0d04a076446a9ad&amp;businessunitId=61aded47ddc90238cd0fc2ac#locale=en-US&amp;styleHeight=24px&amp;styleWidth=100%25&amp;theme=light" style="position: relative; height: 24px; width: 100%; border-style: none; display: block; overflow: hidden;"></iframe></div></div>'));
  
  upperfooter.append(leftColumn);
  upperfooter.append(rightColumn);
  
  
  
  let creator = $('<div class="creator"><a href="mailto:info@wemake.nu">Created by: WeMake</a></div>');
  
  $("#shopify-section-footer-template .tt-footer-custom .col-sm-6:nth-child(2) .tt-col-item").append(creator);
  
  if (windowWidth < 1024){
    $("#shopify-section-footer-template .tt-footer-col .row .col-md-6:nth-child(4)").insertAfter($("#shopify-section-footer-template .tt-footer-col .row .col-md-6:nth-child(1)"));
  }
  
  
  
});